import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { HelmetProvider } from 'react-helmet-async'
import ErrorBoundary from '@/components/ErrorBoundary'
import PerformanceMonitor from '@/components/PerformanceMonitor'
import ServiceWorkerRegistration from '@/components/ServiceWorkerRegistration'

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
      <PerformanceMonitor />
      <ServiceWorkerRegistration />
    </HelmetProvider>
  </ErrorBoundary>
);
